import {EntityData, field} from "@fedeltapointofsale/data-client";

export class SiteData extends EntityData<SiteData> {
    @field groupName: string;
}

export class SiteReferenceData extends EntityData<SiteReferenceData> {
    @field groupName: string;
}
